import React from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { ConsentBanner as AtlassianConsentBanner } from '@atlassian/browser-storage-controls/consent-banner';

import { STATSIG_FEATURE_GATES } from '../../bootstrap/statsigFeatureGates';

export const ConsentBanner = (): React.JSX.Element | null => {
	const showConsentBanner = FeatureGates.checkGate(STATSIG_FEATURE_GATES.CONSENT);

	if (!showConsentBanner) {
		return null;
	}

	return <AtlassianConsentBanner product="Rovo Extension" />;
};
